<template>
  <div id="header">
    <div class="top">
      <div class="wrap">
        <div class="hi">
          <span>Hi，欢迎来到中宁工业园区综合管理服务平台！</span>
        </div>

        <div class="tool_bar" v-if="isLogin">
          <span>{{ userInfo.username }} 您好，<a href="https://manage.zngyy.com/zcfw/#/home"
                                              target="_self">进入后台</a></span>
          <span> | </span>
          <span @click="logout" style="cursor: pointer">退出</span>
        </div>
        <div class="tool_bar" v-else>
          <a href="https://www.zngyy.com/login.thtml?url=qyfw.zngyy.com" target="_self">登录</a>
          <span>|</span>
          <a href="" target="_blank">注册</a>
        </div>

      </div>
    </div>

    <div class="logo_bar">
      <div class="wrap">
        <a href="javascript:void(0)"><img src="../../assets/images/logo_icon.png" alt="" style="width: 60px;height: 60px;margin-right: 10px;"><img src="../../assets/images/logo.png"></a>
      </div>
    </div>

    <div class="nav">
      <div class="wrap">
        <ul>
          <li><a href="" @click.prevent.stop="goPage('/')">首页</a></li>
          <li>
            <a href="#col_sub_tt">业务众包</a>
            <ol class="sub_nav">
              <li><a href="" @click.prevent.stop="goPage('/product/list')">服务产品</a></li>
              <li><a href="" @click.prevent.stop="goPage('/demand/list')">服务需求</a></li>
            </ol>
          </li>
          <li>
            <a href="/#zcfw_anchor">众创服务</a>
          </li>
          <li>
            <a href="/#zfrz_anchor">众扶融资服务</a>
          </li>
          <li>
            <a href="" @click.prevent.stop="goPage('/tec')">产业科技创新服务</a>
          </li>
          <li>
            <a href="https://www.zngyy.com">返回总平台</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from 'ant-design-vue'
import {deleteCookie, getCookie} from "@/utils/common";
import {getUserInfo} from "@/api/home";

export default {
  name: 'BasicHeader',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    subType: {
      type: Boolean,
      default: () => false
    },
  },
  inject: ['reload'],
  data() {
    return {
      navsList: [
        {
          id: 1,
          name: '首页',
          url: '/'
        },
        {
          id: 2,
          name: '校园资讯',
          url: '/info'
        },
        {
          id: 3,
          name: '学院概况',
          url: '/overview'
        },
        {
          id: 4,
          name: '教育教学',
          url: '/education'
        },
        {
          id: 5,
          name: '在线训练课堂',
          url: '/classroom'
        },
        {
          id: 6,
          name: '校园文化',
          url: '/campus'
        },
        {
          id: 7,
          name: '招生就业',
          url: '/recruit'
        }
      ],
      userInfo: {},
      isLogin: false
    }
  },
  async created() {
    const token = getCookie()
    if (token) {
      try {
        const res = await getUserInfo()
        if (res.data) {
          this.isLogin = true
          this.userInfo = res.data
        } else {
          console.error('获取用户信息失败')
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  methods: {
    goPage(url) {
      this.$router.push(url)
    },
    logout() {
      deleteCookie()
      this.isLogin = false
      location.reload()
    },
    handleLogout() {
      Modal.confirm({
        title: '信息',
        content: '您确定要注销登录吗？',
        onOk: () => {
          return this.$store.dispatch('Logout').then(() => {
            this.reload();
          })
        },
        onCancel() {
        }
      })
    }
  }
}
</script>


<style scoped>
.wrap {
  margin: 0 auto;
  width: 1200px;
}

.top {
  width: 100%;
  min-width: 1200px;
  background-color: #f0f2f7;
  padding: 5px 0;
  position: relative;
}

.top .hi {
  font-size: 14px;
}

.top .wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top img {
  position: relative;
  top: 3px;
}

.top i {
  color: #2e9bfe;
  font-size: 15px;
  letter-spacing: 1px;
  font-style: normal;
  font-weight: bold;
}

.tool_bar {
  position: relative;
}

.tool_bar span {
  top: -1px;
  position: relative;
}

.logo_bar {
  padding: 25px 0 18px;
}

.logo_bar .wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.news_search {
  display: flex;
}

input::-webkit-input-placeholder {
  color: #9B9B9B !important;
}

.news_search .in_bar {
  border: 1px solid #d3d3d3;
  height: 38px;
  width: 321px;
  border-radius: 5px 0 0 5px;
  padding-left: 10px;
}

.nav {
  min-width: 1200px;
  width: 100%;
  height: 53px;
  background: url(../../assets/images/nav_bg.jpg) repeat;
}

.nav .wrap {
  height: 100%;
}

.nav ul {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav ul > li {
  height: 100%;
  position: relative;
  z-index: 999;
  margin-right: 15px;
  min-width: 110px;
  text-align: center;
}

.nav ul li.on {
  background-color: #0075ed;
}

.nav ul li .sub_nav {
  background-color: #4a8df5;
  overflow: hidden;
  visibility: hidden;
}

.nav ul li .sub_nav li a {
  padding: 10px 16px;
}

.nav ul li a {
  color: #fff;
  padding: 0 15px;
  display: block;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 15px;
  justify-content: center;
}

.nav ul li:hover > a {
  background-color: #0075ed;
}

.nav ul li:hover > .sub_nav {
  visibility: visible;
}
</style>
